// extracted by mini-css-extract-plugin
export default {"warn":"PickupDateTemplate_warn__JeMOK"};